export default __webpack_public_path__ + "static/media/Gentle_Sniper.0324e567.jpg";